import { createUseStyles } from 'react-jss';

var styles = {
  productName: {
    fontSize: '2rem',
    lineHeight: '2.6rem',
    margin: 0,
    marginRight: '1rem'
  },
  selectedProductIcon: {
    marginLeft: '-1rem',
    marginRight: '1.5rem'
  }
};

var createStyles = createUseStyles(styles);
export { createStyles };
//# sourceMappingURL=styles.js.map